import { dialog, IDialog } from '@Common/Controls/Dialog';
import { Input } from '@Common/Controls/Input';
import { GridLayout, IGridCellDescription, IGridRowDescription } from '@Common/Controls/GridLayout';
import { TypeKind } from '@Common/Enums';
import urlHelper from '@Common/Helpers/UrlHelper';
import { Control } from '@Common/Controls';

export interface IErrorDialogParameters {
    title?: string;
    message?: string;
    exceptionMessage?: string | JQuery | Control;
    exceptionBody?: string;
}

export function errorDialog(param?: IErrorDialogParameters): ErrorDialog {
    return new ErrorDialog(param);
}

export class ErrorDialog {
    private _cancel: IHandler = _.noop;

    private readonly dialog: IDialog;
    private readonly root: GridLayout;
    private exceptionMessageControl: Input;

    constructor(private readonly param: IErrorDialogParameters) {
        this.param = _.defaults<IErrorDialogParameters, IErrorDialogParameters>(this.param, {
            title: strings.applicationName,
            message: strings.errorDialog.unknownError,
            exceptionMessage: '',
            exceptionBody: ''
        });

        this.root = this.getLayout();
        this.dialog = this.createDialog();
    }

    public show(): void {
        this.dialog.wrap(this.root.getControl());
        this.dialog.resize();
    }

    public cancel(fn: IHandler): void {
        if (_.isFunction(fn)) {
            this._cancel = fn;
        }
    }

    private getLayout(): GridLayout {
        const cells: IGridCellDescription[] = [
            {
                rowIndex: 0,
                columnIndex: 0,
                table: {
                    columns: [{ style: { width: '48px' } }, {}],
                    rows: [{}],
                    cells: [
                        {
                            rowIndex: 0,
                            columnIndex: 0,
                            content: $(`<img src="${urlHelper.getImageUrl('error.png')}" />`)
                        },
                        {
                            rowIndex: 0,
                            columnIndex: 1,
                            content: this.param.message,
                            className: 'text-wrap'
                        }
                    ]
                }
            }
        ];

        const rows: IGridRowDescription[] = [{ style: { height: 'auto' } }];

        if (this.param.exceptionMessage) {
            let bodyContent;

            if (_.isString(this.param.exceptionMessage)) {
                bodyContent = this.exceptionMessageControl = new Input({
                    type: TypeKind.text,
                    width: '100%',
                    height: '100%'
                });
                this.exceptionMessageControl.getControl().prop('readonly', true);
                this.exceptionMessageControl.setValue(this.param.exceptionMessage);
            } else {
                bodyContent = this.param.exceptionMessage;
            }

            rows.push({ style: { height: 'auto' } }, {});
            cells.push(
                {
                    rowIndex: 1,
                    columnIndex: 0,
                    content: strings.errorDialog.reason
                },
                {
                    rowIndex: 2,
                    columnIndex: 0,
                    content: bodyContent
                }
            );
        }

        return new GridLayout({
            columns: [{}],
            rows: rows,
            cells: cells
        });
    }

    private createDialog(): IDialog {
        const dlg = dialog({
            title: this.param.title,
            minHeight: this.param.exceptionMessage ? 320 : 130,
            minWidth: 300,
            width: 800,
            canSwitchToFullScreen: !!this.param.exceptionMessage,
            resizable: !!this.param.exceptionMessage,
            buttons: this.getButtons()
        });
        dlg.ok(() => this._cancel());
        dlg.cancel(() => this._cancel());
        dlg.onResize((width: number, height: number) => this.root.adjust(width, height));

        return dlg;
    }

    private getButtons(): any[] {
        if (this.param.exceptionMessage && this.param.exceptionBody) {
            return [
                {
                    text: strings.errorDialog.details,
                    ready: button => {
                        if (this.param.exceptionBody) {
                            this.exceptionMessageControl.setValue(this.param.exceptionBody);
                        }

                        button.setState(false);
                    }
                }
            ];
        }
        return [];
    }
}
